import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import "dayjs/locale/fa";
// import moment from "moment";
import moment from "moment-jalaali";
import { FC } from "react";
import { getMonthName } from "utils/formatTime";

interface IMonth {
  startOfMonth: string;
  endOfMonth: string;
  name: string;
}
interface IMonthPickerProps {
  value: IMonth | undefined;
  onChange: (newValue: IMonth) => void;
  label: string;
}

export const MonthPicker: FC<IMonthPickerProps> = (props) => {
  const { onChange, value, label } = props;

  const currentMonth = getCurrentMonth();

  function getMonthByLabel(month: string) {
    return MONTHS.find(({ name }) => name === month)!;
  }

  return (
    <>
      {/* <FormControl fullWidth> */}
      <DatePicker
        label={label}
        openTo="month"
        views={["year", "month"]}
        sx={{ width: "100%" }}
        slots={{ actionBar: () => null }}
        closeOnSelect
        onChange={(value) => {
          onChange({
            startOfMonth: moment(value)
              .startOf("jMonth")
              .utc()
              .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
            endOfMonth: moment(value)
              .endOf("jMonth")
              .utc()
              .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
            name: moment(value).format("jMMMM"),
          });
        }}
      />
      {/* <InputLabel id="month-picker">{label}</InputLabel>
        <Select
          labelId="month-picker"
          label={label}
          defaultValue={currentMonth.name}
          value={value?.name}
          onChange={(e) => onChange(getMonthByLabel(e.target.value as string))}
          fullWidth
        >
          {MONTHS.map((item) => (
            // @ts-ignore
            <MenuItem key={item.startOfMonth} value={item.name}>
              {item.name}
            </MenuItem>
          ))}
        </Select> */}
      {/* </FormControl> */}
    </>
  );
};

export function getCurrentMonth(): IMonth {
  const jYear = moment().format("jYYYY");
  const jMonth = moment().format("jMM");

  const startOfMonth = new Date(
    moment(`${jYear}-${jMonth}`, "jYYYY-jMM-jDD").format()
  ).toISOString();
  const endOfMonth = new Date(
    moment(startOfMonth).endOf("jMonth").format()
  ).toISOString();

  const name = getMonthName(startOfMonth);

  return {
    name,
    endOfMonth,
    startOfMonth,
  };
}

const monthsOrder = {
  فروردین: 1,
  اردیبهشت: 2,
  خرداد: 3,
  تیر: 4,
  مرداد: 5,
  شهریور: 6,
  مهر: 7,
  آبان: 8,
  آذر: 9,
  دی: 10,
  بهمن: 11,
  اسفند: 12,
};

export const MONTHS: IMonth[] = Array.from(Array(12))
  .map((_, index) => {
    const currentYear = moment().jYear();
    const monthIndex = index + 1 < 10 ? `0${index + 1}` : `${index + 1}`;

    const startOfMonth = new Date(
      moment(`${currentYear}-${monthIndex}-01`, "jYYYY-jMM-jDD").format()
    ).toISOString();
    const endOfMonth = new Date(
      moment(startOfMonth).endOf("jMonth").format()
    ).toISOString();

    const name = getMonthName(startOfMonth);

    return { startOfMonth, name, endOfMonth };
  })
  // @ts-ignore
  .sort((a, b) => monthsOrder[a.name] - monthsOrder[b.name]);
